<div class="flex flex-col basis-full m-20">
    <div class="flex-row display" mat-dialog-content>
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      <div class="fw-600 fs-24">{{'INSTANCE_SUMMARY.MENU.SECRETS' | transloco}}</div>
    </div>
    <div class="flex flex-row">
        <div class="fw-400 fs-14 head-name pr-10">{{ serviceTitle }} : {{ blueprintTitle }}</div>
        <div class="fw-400 fs-14 head-name pl-10 pr-10">{{ 'BLUEPRINT_SUMMARY.SIDE_MENU.SERVICE_DEFINITION' | transloco }} : {{serviceDefinition}}</div>
        <div class="fw-400 fs-14 head-name pl-10 pr-10">{{ 'Environment :'}} {{environment}}</div>
        <div class="fw-400 fs-14 pl-10 pr-10">{{ 'Instance Name :'}} {{instanceName}}</div>
    </div>
    <mat-divider class="mt-8"></mat-divider>
    <div class="flex flex-row">
      <div class="flex flex-col left-nav">
        <ng-container *ngIf="capabilityIncluded.length > 0">
          <div class="pt-16 fw-400 fs-12">{{ 'CAPABILITIES.INCLUDED_CAPABILITIES' | transloco }}</div>
          <div class="flex flex-row items-center p-8 w-240" *ngFor="let capability of capabilityIncluded"
          [ngClass]="[ currentStep === capability.step ? 'questionnaire-steps' : 'unselected-text' ]">
            <div class="flex mat-body fw-600 cursor-pointer w-100-percent" (click)="onClick(capability,'CAPABILITIES.INCLUDED_CAPABILITIES')">
              <span class="max-limit-per-line" [ngClass]="[ currentStep === capability.step ? 'questionnaire-steps' : 'unselected-text' ]">
                {{capability?.displayName ? (capability?.displayName) : ((capability?.name) ? (capability?.name) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}
              </span>
            </div>
            <ng-container *ngIf="capability.validated">
              <mat-icon svgIcon="done" class="icon-sm mr-12 unselected-text"></mat-icon>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="capabilityOptional.length > 0">
          <div class="pt-16 fw-400 fs-12">{{ 'CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco }}</div>
          <div class="flex flex-row p-8 w-240" *ngFor="let capability of capabilityOptional"
          [ngClass]="[ currentStep === capability.step ? 'questionnaire-steps' : 'unselected-text' ]">
            <div class="flex items-center mat-body fw-600 cursor-pointer" (click)="onClick(capability,'CAPABILITIES.INCLUDED_CAPABILITIES')">
              <span [ngClass]="[ currentStep === capability.step ? 'questionnaire-steps' : 'unselected-text' ]">
                {{capability?.displayName ? (capability?.displayName | titlecase) : ((capability?.name) ? (capability?.name | titlecase) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}
              </span>
            </div>
            <ng-container *ngIf="capability.validated">
              <mat-icon svgIcon="done" class="icon-sm mr-12 unselected-text"></mat-icon>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="flex flex-col right-nav">
          <div class="fw-600 fs-24 pt-8" *ngIf="displayName">{{headerData}}</div>
          <mat-divider class="mt-8" *ngIf="displayName"></mat-divider>
          <div class="pr-8 mt-24" [ngClass]="{'overflow-class': secretKeyData}">
            <section class="flex justify-center items-center spinner" *ngIf="dataLoading; else showForm">
              <mat-spinner diameter="40"></mat-spinner>
            </section>
            <ng-template #showForm>
              <app-dynamic-form *ngIf="secretKeyData && displayName; else errorForm" [dynamicFormModel]="installationSpecificationForms[0]">
              </app-dynamic-form>
            </ng-template>
            <ng-template #errorForm >
              <div *ngIf="displayName; else errorDisplayForm" class="flex flex-col items-center mt-16">
                <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                <div class="fw-500 fs-24 failed-title mt-16">{{'INSTANCE_SUMMARY.MENU.SECRET_SPECIFICATION_NOT_AVAILABLE' | transloco}}</div>
              </div>
            </ng-template>
            <ng-template #errorDisplayForm >
              <div *ngIf="!displayName && !dataLoading" class="flex flex-col items-center mt-16">
                <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                <div class="fw-500 fs-24 failed-title mt-16">{{'INSTANCE_SUMMARY.MENU.COMPONENT_NOT_AVAILABLE' | transloco}}</div>
              </div>
            </ng-template>
        </div>
      </div>
    </div>
    <div class="summary-header max-width-lg mt-auto">
      <div class="flex flex-row items-center">
        <mat-icon svgIcon="arrow_back" class="icon-sm cursor-pointer mr-8"  [ngClass]="[ currentStep === 0 ? 'disabled' : 'enabled' ]" (click)="goToPrevious()"></mat-icon>
        <div class="mat-subtitle-2 fw-700 mb-0 cursor-pointer" [ngClass]="[ currentStep === 0 || !displayName? 'disabled' : 'enabled' ]" (click)="goToPrevious()">
          {{ 'BUTTONS.PREVIOUS' | transloco }}
        </div>
        <button class="flex items-center cancel-btn ml-auto mr-26 p-16 pl-42 pr-42" (click)="matdialogRef.close()">
          <mat-icon svgIcon="close" class="icon-sm cursor-pointer mr-8"></mat-icon>
          {{ 'BUTTONS.CANCEL' | transloco }}
        </button>
        <button *ngIf="currentStep !== capabilities.length - 1; else showSetupButton"
          class="flex items-center mossgreen primary-fg p-16 pl-42 pr-42" [ngClass]="isValid && (!displayName || !dataLoading)? 'cursor-none' : 'cursor-pointer'" type="button"
          (click)="goToNext()">{{ 'BUTTONS.CONTINUE' | transloco }}
          <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
        </button>
        <ng-template #showSetupButton>
          <div class="button-container">
            <button class="flex items-center mossgreen primary-fg ml-auto mr-26 p-16 pl-42 pr-42" [ngClass]="isValid && !displayName? 'cursor-none' : 'cursor-pointer'" type="button" (click)="submit()">
              {{ 'BUTTONS.SUBMIT' | transloco }}
              <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
</div>

